import type { ComponentType, SVGProps } from "react";

import type {
  NotificationSize,
  NotificationTone,
  NotificationVariant,
} from "./Notification.types";
import ErrorIcon from "./images/error.svg?react";
import InformationIcon from "./images/information.svg?react";
import QuestionIcon from "./images/question.svg?react";
import SuccessIcon from "./images/success.svg?react";
import WarningIcon from "./images/warning.svg?react";

export const toneClassMap: Record<NotificationTone, string> = {
  success: "ToneSuccess",
  error: "ToneError",
  information: "ToneInformation",
  warning: "ToneWarning",
  question: "ToneQuestion",
};

export const sizeClassMap: Record<NotificationSize, string> = {
  desktop: "SizeDesktop",
  mobile: "SizeMobile",
};

export const variantClassMap: Record<NotificationVariant, string> = {
  default: "VariantDefault",
  title: "VariantTitle",
};

export const toneIconMap: Record<
  NotificationTone,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  success: SuccessIcon,
  error: ErrorIcon,
  information: InformationIcon,
  warning: WarningIcon,
  question: QuestionIcon,
};
